module.exports = __webpack_public_path__ + "img/W-G38.0d71e8f9.jpg";